export const emptyQueueObject = {
  agentDetails: {},
  agentsIds: [],
  scope: "",
  language: "en-US",
  huntMethod: "roundRobin",
  maxAlertTime: 40,
  maxInQueue: 30,
  announcePositionInQueue: false,
  announceEstimatedWaitTime: false,
  keepAgentOnRequeue: false,
  fallbackIfNoAgentConnected: false,
  enableVipPriority:false,
  vipIds:[],
  vipDetails:{},
  queueFallBackMessage: {
    enabled: false,
    fileName: "",
    type: "",
    language: "en-US",
    text: "",
    audioFileUrl: "",
  },
  authorizedActivityValues: ["Available"],
  waitTimeIntervals: ["1", "3", "5"],
  sla: 60,
  wrapUpTime: 0,
  slaThreshold: 50,
  tasks: {},
  calls: {},
  musicOnHold: [
    {
      header: "default.wav",
      url: "https://callcenterconf.blob.core.windows.net/tenants/de5e3c28-141c-4d3e-90ea-aa3326abe67d/default/media/Urban Sunrise.wav",
    },
  ],
  queueName: "",
  queueOverflow: {
    displayName: "",
    type: "disconnect",
    targetType: "user",
    targetId: "",
    queueId: "",
    queueDisplayName: "",
  },
  maxWaitTime: 1200,
  integrationParams: {
    servicetype: "none",
    serviceURL: "",
    method: "POST",
    headers: {}
  },
  closeCRMPopUpOn: "CALL_RING_END",
  defaultReasonCode: "READY",
  reasonCodes: [
    "READY",
    "COFFEE_BREAK",
    "ADMIN WORK",
    "OUT OF SHIFT",
    "UNAVAILABLE"
  ],
  channels: { call: true },
};
